<template>
  <div class="pt-3 pl-5 pr-5 page-fill">
    <div v-if="isLoading">
      <breadCrumbs
        :routesArray="routesArray"
      ></breadCrumbs>
      <div class="row w-full justify-between flex" style="align-items: center">
        <h1 class="title">Import Controls</h1>
        <div class="cardbody flex">
          <div class="flex flex-row-reverse items-center gap-3">
            <button
              class="flex"
              @click="filterOpen"
              :class="
                tableRow.length == 0
                  ? 'filterButtondisabled pointer-events-none'
                  : 'filterButton'
              "
            >
              <img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
              <img v-else src="@/assets/filter.svg" class="h-3 ml-2.5" />
              Filters
            </button>
            <button
              class="btnprimary"
              v-if="this.controlsList.length > 0"
              @click="saveImportedControls()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="row flex flex-row justify-between items-center w-full upperspacing flex-wrap" v-if="this.tableRow.length == 0">
        <!-- @select="selectedDepartmentfromList" -->
        <div class="w-6/12 pr-2">
          <label class="controllabel">Departments</label>
          <Multiselect
            v-model="controlDept.selectedDepartment"
            :options="allDeptOptions"
            :showNoOptions="false"
            @search-change="asyncFind"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="true"
            open-direction="bottom"
            label="label"
            track-by="value"
            :searchable="true"
            :hideArrow="false"
            placeholder="Departments"
            class="custom-multiselect userSelect mt-2"
            :class="{
              'is-invalidmultiselect': v$.controlDept.selectedDepartment.$error,
            }"
          >
            <template v-slot:noResult>
              <span class="text-xs">No Departments Found</span>
            </template>
          </Multiselect>
          <div v-if="v$.controlDept.selectedDepartment.$error" class="text-red-500">
            <div class="error-text" v-if="v$.controlDept.selectedDepartment.required.$invalid">
              Required
            </div>
          </div>
        </div>
        <!-- <div class="w-6/12 pr-2">
          <label class="controllabel">Entity</label>
          <div v-if="isGlobal" class="text-sm inputboxstyling mt-2">
            {{controlDept.entity}}
          </div>
          <Multiselect
            v-else
            v-model="controlDept.entity"
            :options="allEntityOptions"
            :showNoOptions="false"
            :disabled="departmentSelected"
            @search-change="asyncFind2"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="true"
            :hide-selected="true"
            open-direction="bottom"
            label="label"
            track-by="value"  
            :searchable="true"
            :hideArrow="false"
            placeholder="Entity"
            class="custom-multiselect userSelect mt-2"
            :class="{
            'is-invalid borderRed': v$.controlDept.entity.$error
          }"
          >
          </Multiselect>
          <div v-if="v$.controlDept.entity.$error" class="text-red-500">
            <div class="error-text" v-if="v$.controlDept.entity.required.$invalid">Required</div>
          </div>

        </div> -->
        <div class="w-6/12">
          <label class="controllabel">Import File</label>
          <div
            class="mt-2 w-auto bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden inputFieldHeight"
          >
            <!-- <label htmlFor="upload" class="controllabel">Upload File</label> -->
            <input
              type="file"
              ref="fileInput"
              class="hidden"
              id="upload"
              :class="!controlDept.selectedDepartment || controlDept.selectedDepartment == '' ? 'btndisabled pointer-events-none' : ''"
              @change="fileReader($event, controlDept)"
            />
            <!--  :class="controlDept.selectedDepartment.length == 0 ? 'btndisabled pointer-events-none' : ''" -->
            <label
              for="upload"
              class="float-right cursor-pointer text-white flex justify-center items-center w-9 h-8 bg-primary pb-1" :class="!controlDept.selectedDepartment || controlDept.selectedDepartment == ''  ? 'btndisabled1 pointer-events-none' : ''"
              ><img src="@/assets/Browse.svg"
            /></label>
            <!-- <div v-if="fileName" class="text-xs p-1">{{ fileName }}</div> -->
          </div>
          <!-- <input
            type="file"
            accept=".xls,.xlsx"
            class="hidden"
            ref="file"
            @change="fileReader($event)"
          /> -->
        </div>
      </div>
      
      <div>
        <tableData class="flex-1 min-h-0 table-section" :tableRowData="tableRow" :headersData="headers"></tableData>
      </div>
    </div>
    <!-- <loader v-if="showLoader" /> -->
  </div>
</template>
<style  scoped>
.multiselect-tag {
  font-size: 12px;
  font-weight: 600;
}
.inputFieldHeight{
  height: 30px;
}
.multiselect-tag.is-disabled {
  background-color: #059669 !important;
}
.multiselect.is-disabled {
  background-color: white !important;
}
.tbodylast:last-child {
  border-bottom: 1px solid #e9e9e9;
}
::-webkit-scrollbar {
  width: 3px !important;
}
.borderRed {
  border: 1px solid red !important;
}
.btndisabled1 {
    /* border-radius: 0.25rem; */
    --tw-bg-opacity: 1;
    background-color: rgb(233 233 233 / var(--tw-bg-opacity));
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    padding-top: 0.625rem;
    padding-bottom: 14px;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: .75rem;
    --tw-text-opacity: 1;
    color: rgb(77 77 77 / var(--tw-text-opacity));
}
</style>
<script lang="ts">
import { emitter, toast } from "@/main";
import * as XLSX from "xlsx";
import _ from "lodash";
import { defineComponent } from "vue";
// import loader from "../../components/loader.vue";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { groupBy } from "lodash";
import Multiselect from "vue-multiselect";
import tableData from "@/components/tableData.vue";
import breadCrumbs from "@/components/breadCrumb.vue";
export default defineComponent({
  data(): any {
    return {
      headers: ["departments", "controlImportTitle", "class", "family", "entityName","deleteIcon"],
      filteredControlFamilyOptions: [],

      v$: useVuelidate(),
      showBlock: false,
      showDropdown: false,
      isLoading: false,
      showLoader: false,
      allEntityOptions:[],
      showFilters: false,
      showModal: false,

      dummyList: [],
      controlsList: [],
      departmentsList: [],
      selectedControlForKPI: {},
      kpiListForControl: [],
      selectedControl: {},
      ControlFamilyArray: [],

      filters: {},

      isGlobal: false,
      tableRow: [],
      controlFamilies: [],
      nonTableRow: [],
      allDeptOptions: [],
      columnObject: false,
      
      departmentSelected:true,
      priority: ["Critical", "High", "Moderate", "Low"],
      priorityArray: [
        { label: "Very Low", id: 1 },
        { label: "Low", id: 2 },
        { label: "Moderate", id: 3 },
        { label: "High", id: 4 },
        { label: "Critical", id: 5 },
      ],
      editObject: {},
      deptOptions: [],
      entitiesArray:[],
      internalControlsArray: [],
      dummyInternalControls: [],
      dummyNonInternalControls: [],
      controlDepartmentArr: [],
      controlTypeArray: [
        { label: "Preventive", id: 1 },
        { label: "Detective", id: 2 },
        { label: "Corrective", id: 3 },
        { label: "Deterrent", id: 4 },
        { label: "Directive", id: 5 },
        { label: "Recovery", id: 6 },
        { label: "Compensating", id: 7 },
      ],
      controlDept: {
        entity:'',
        selectedDepartment: []
      },
      controlFrequency: [
        { label: "Transactional", id: 1 },
        { label: "Daily", id: 2 },
        { label: "Weekly", id: 3 },
        { label: "Monthly", id: 4 },
        { label: "Quarterly", id: 5 },
        { label: "Semi Annualy", id: 6 },
        { label: "Annualy", id: 7 },
        { label: "Ad-Hoc", id: 8 },
      ],
      optionsValue: [
        {
          id: 1,
          value: "KPI",
          route: "/manageKPI",
          presentRoute: "/org/controls/active",
        },
      ],
      dummyControlList: [],
      fullKeys: [
        // "controlNumber",
        "controlTitle",
        "controlGuidance",
        "controlClass",
        "controlFamily",
        "controlType",
        "controlPriority"
      ],
      routesArray: [],
      filteredDeptOptions:[],
      entitiesOptions: []
    };
  },
  validations: {
    controlDept: {
      entity:{ required },
      selectedDepartment: { required },
    }
  },
  components: {
    // loader,
    Multiselect,
    tableData,
    breadCrumbs
  },
  async mounted() {
    emitter.on("*", (type, booleanValue) => {
      if (type == "apps-sidemenubar" || type == "toggle-sidebar") {
        this.showBlock == true
          ? ((this.showBlock = false), (this.showDropdown = false))
          : "";
      } else {
        if (this.showBlock == true) {
          if (this.showDropdown == false) {
            this.showDropdown = true;
          } else {
            this.showDropdown = false;
            this.showBlock = false;
          }
        } else {
          this.showDropdown = false;
        }
      }
    });
    emitter.off("deleteControlFromTable");
    emitter.on("deleteControlFromTable", (data: any) => {
      this.clickedOnDeleteButton(data.index);
    });
    this.routesArray = [
      { name: "Active Controls", routeName: "Active-Controls" },
      { name:'Import Controls', routeName: "actionTask" },
    ];
  },
  async created() {
    await this.orgFetchControlsInfo();
    await this.orgFetchInternalControlsInfo();
    await this.fetchDepartmentsList();
    
    await this.getallEntities();
  },
  computed: {
    disableStatus: function (): any {
      let disableStatusCondition;
      if (this.controlObject._id) {
        if (
          JSON.stringify(this.controlObject) == JSON.stringify(this.editObject)
        ) {
          disableStatusCondition = false;
        } else {
          disableStatusCondition = true;
        }
      } else {
        let val: any = [];
        Object.values(this.controlObject).forEach((value: any) => {
          val.push(value);
        });
        for (let n of val) {
          if (n != "") {
            disableStatusCondition = true;
          }
        }
      }
      return disableStatusCondition;
    },
  },
  methods: {
    asyncFind(query: any) {
      if (query == "") {
        this.allDeptOptions = [];
      } else if (query.length >= 1) {
        this.allDeptOptions = this.filteredDeptOptions.filter((obj: any) => {
          return obj.label.toLowerCase().includes(query.toLowerCase());
        });
      }
    },
    asyncFind2(query:any){
      if(query == ''){
          this.allEntityOptions = []
      }else if(query.length >= 1){
          this.allEntityOptions = this.entitiesOptions.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
      }
    },
    clickedOnDeleteButton(index: number) {
      this.tableRow.splice(index, 1);
      this.controlsList.splice(index, 1);
    },
    async addControlSource(action: any, controlObject: any) {
      try {
        
        let payloadForControlIds: any = [];
        let controlRouteIds: any[] = [];
        // if(this.dummyNonInternalControls && this.dummyNonInternalControls.length > 0){
          let payload: any = [];
          let framework = 'InternalControls'
          const temp = {
            controlFrameWork: framework,
            controlsList: this.controlsList,
          };
          payload.push(temp);
          // let departmentId = controlObject.departments
          payload[0].controlsList.forEach((obj: any) => {
            if(obj.departments){
              delete obj.departments;
            }
          });
          await this.$http
          .post(
            `${process.env.VUE_APP_CONTROLS_API}/api/org/controlset/create`,
            payload
          )
          .then(async (result: any) => {
            controlRouteIds = Object.values(result.data.insertedIds);
          });
        // }
        if(controlRouteIds && controlRouteIds.length > 0){
          let departmentRouteId = controlObject.selectedDepartment.value;
          let departmentRouteObj = this.departmentsList.find((obj: any)=>{
            return obj._id == departmentRouteId
          })
          this.dummyInternalControls.forEach((control:any) =>{
            controlRouteIds.push(control._id)
          })
          // if(controlRouteIds != null || controlRouteIds != undefined){
          //   controlRouteIds.map((obj: any)=>{
          //     controlRouteIds.push(obj)
          //   });
          // }.
          if(departmentRouteObj.entityType == 20301) {
              payloadForControlIds = [
                  { 
                      departmentId: departmentRouteId,
                      // entityId: 'global',
                      controlIds: controlRouteIds,
                      entitytypecodeid: 20301
                  }
              ];
          } else if(departmentRouteObj.entityType == 20303) {
              payloadForControlIds = [
                  {
                      departmentId: departmentRouteId,
                      entityId: departmentRouteObj.entityId,
                      controlIds: controlRouteIds,
                      entitytypecodeid: 20303
                  }
              ];
          }
          await this.$http
            .post(
              `${process.env.VUE_APP_CONTROLS_API}/api/org/controls/manageDepartments`,
              payloadForControlIds
            )
            .then(() => {
              if (action == "toast") {
                toast.info(`Saved Successfully`, {
                  timeout: 1000,
                  closeOnClick: true,
                  closeButton: "button",
                  icon: true,
                });
              }
              this.$router.push({ name: 'Active-Controls' });
          });
        }  
        // await this.makeTable();
      } catch (e) {
        toast.error(`Something went wrong`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
    },
    async getallEntities() {
      this.entitiesOptions = [];
      let result: any;
      await this.$http
        .get(
          `${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`
        )
        .then((res: any) => {
          result = res.data;
          this.allEntities = res.data;
        });
      for (var i = 0; i < result.length; i++) {
        this.entitiesArray.push({
          label: result[i].entityName,
          value: result[i]._id,
        });
      }
    },
    makeTable() {
      this.tableRow = [];
      if (this.controlsList.length > 0) {
        let departmentRouteObj = this.departmentsList.find((obj: any)=>{
          return obj._id == this.controlDept.selectedDepartment.value
        })
        let entityDataWithDept = departmentRouteObj.entityType == 20303 ? departmentRouteObj.entityDisplayName : departmentRouteObj.displayName
        this.controlsList.forEach((item: any) => {
          let tableObj: any;
          tableObj = {
            departments: this.controlDept.selectedDepartment.label,
            // number: item.controlNumber ? item.controlNumber : "N/A",
            controlImportTitle: item.controlTitle ? item.controlTitle : "N/A",
            class: item.controlClass ? item.controlClass : "N/A",
            family: item.controlFamily ? item.controlFamily : "N/A",
            entityName: entityDataWithDept ? entityDataWithDept : 'N/A'
          };

          this.tableRow.push(tableObj);
        });

        this.columnObject = false;
      } else {
        this.columnObject = true;
        this.tableRow.push({
          departments: "",
          controlImportTitle: "",
          class: "",
          family: "",
        });
      }
    },
    async orgFetchControlsInfo() {
      this.controlsList = [];
      this.showLoader = true;
      this.isLoading = false;
      await this.$http
        .get(
          `${process.env.VUE_APP_CONTROLS_API}/api/org/controls/active`
        )
        .then((result: { data: any }) => {
          this.isLoading = true;
          this.showLoader = false;
          // result.data.forEach((item: any) => {
          // 	// if (item.isInternalControl) {
          // 		this.controlsList.push(item);
          // 	// }
          // });
          this.dummyControlList = [...result.data];
        })
        .catch((error: any) => {
          this.isLoading = false;
          (this.showLoader = false),
            toast.error(`Save failed with ${error}`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: "button",
              icon: true,
            });
        });
      //this.makeTable();
    },
    async orgFetchInternalControlsInfo() {
      this.controlsList = [];
      this.showLoader = true;
      this.isLoading = false;
      await this.$http
        .get(
          `${process.env.VUE_APP_CONTROLS_API}/api/org/allControls?frameWork=InternalControls`
        )
        .then((result: { data: any }) => {
          this.isLoading = true;
          this.showLoader = false;
          // result.data.forEach((item: any) => {
          // 	// if (item.isInternalControl) {
          // 		this.controlsList.push(item);
          // 	// }
          // });
          this.internalControlsArray = [...result.data];
        })
        .catch((error: any) => {
          this.isLoading = false;
          (this.showLoader = false),
            toast.error(`Save failed with ${error}`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: "button",
              icon: true,
            });
        });
      //this.makeTable();
    },
    async saveImportedControls() {
      let total = this.tableRow.length;
      let valid = 0;
      let controlSets: any = [];
      if (this.internalControlsArray) {
        this.controlsList.forEach((item: any) => {
          let obj1 = this.internalControlsArray.find((control: any) => control.controlNumber === item.controlNumber);
          if (obj1) {
            this.dummyInternalControls.push(obj1);
          } else {
            this.dummyNonInternalControls.push(item);
          }
        });
      }
      let dummyLength = 0
      let dummynonLength = 0

      if(this.dummyInternalControls && this.dummyInternalControls.length > 0){
        dummyLength = this.dummyInternalControls.length
      }
      if(this.dummyNonInternalControls && this.dummyNonInternalControls.length > 0){
        dummynonLength = this.dummyNonInternalControls.length
      }
      controlSets = dummynonLength + dummyLength;
      valid = valid + controlSets;
      await this.addControlSource("toast", this.controlDept);
      if (controlSets > 0) {
        toast.info(
          `Imported ${total} rows, Valid rows: ${valid}, Ignored rows: ${
            total - valid
          }`,
          {
            timeout: 1000,
            closeOnClick: true,
            closeButton: "button",
            icon: true,
          }
        );
      } else {
        toast.error(`Something went wrong`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
    },
    fileReader(oEvent: any): any {
      const oFile = oEvent.target.files[0];

      // Check if the file is an .xlsx file
      if (oFile && oFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        const reader = new FileReader();
        reader.onload = async (e: any) => {
          let data: any = e.target.result;
          data = new Uint8Array(data);
          var workbook = XLSX.read(data, { type: "array" });
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var jsonObj = XLSX.utils.sheet_to_json(worksheet, {
            raw: true,
            header: this.fullKeys,
            range: 1,
          });
          let jsonArray: any = [];
          // const uniqueControlNumbers = new Set<string>();
          let booleanValue = true;
          let framework = "";

          for (let i = 0; i < jsonObj.length; i++) {
            let item: any = jsonObj[i];
            let arr = [
              // "controlNumber",
              "controlFamily",
              "controlClass",
              "controlTitle",
              "controlPriority",
              "controlType",
              'controlFrequency'
            ];
            let mandatoryCondition = arr.every((key: any) => {
              return Object.keys(item).includes(key) && item[key];
            });
            
            let PriorityObj = this.priorityArray.find((obj: any) => {
              return obj.label == item.controlPriority;
            });
            if (PriorityObj) {
              item.controlPriority = PriorityObj.id;
            } 
            let FrequencyObj = this.controlFrequency.find((obj: any) => {
              return obj.label == item.controlFrequency;
            });
            if (FrequencyObj) {
              item.controlFrequency = FrequencyObj.id;
            }

            // let controlCheck;

            if (mandatoryCondition) {
              // if (this.dummyControlList && this.dummyControlList.length != 0) {
              //   controlCheck = this.dummyControlList.some((control: any) => {
              //     if (this.controlDept.selectedDepartment.type == 20301 && control.departments == this.controlDept.selectedDepartment.value) {
              //       return control.controlNumber == item.controlNumber;
              //     } else {
              //       if (control.departments == this.controlDept.selectedDepartment.value && control.entity == this.controlDept.entity.value) {
              //         return control.controlNumber == item.controlNumber;
              //       }
              //     }
              //   });
              // }
              // if (!uniqueControlNumbers.has(item.controlNumber)) {
                booleanValue = false;
                framework = "InternalControls";
                // if (!controlCheck) {
                  jsonArray.push(item);
                // }
                // uniqueControlNumbers.add(item.controlNumber);
              // }
            }
          }
          this.controlsList = jsonArray;
          if (this.controlsList && this.controlsList.length == 0) {
            toast.error(`Controls should be unique for same department`, {
              timeout: 5000,
              closeOnClick: true,
              closeButton: "button",
              icon: true,
            });
          }
          this.makeTable();
        };
        reader.readAsArrayBuffer(oFile);
      } else {
        toast.error(`Please upload a valid .xlsx file`, {
          timeout: 5000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
    },
    async fetchDepartmentsList() {
      this.showLoader = true;
      await this.$http
        .get(`${process.env.VUE_APP_ORG_API}/departments/get`)
        .then((res: { data: any }) => {
          this.isLoading = true;
          this.showLoader = false;
          this.departmentsList = res.data;
        })
        .catch((error: any) => {
          this.isLoading = false;
          (this.showLoader = false),
            toast.error(`Save failed with ${error}`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: "button",
              icon: true,
            });
        });
        this.deptOptions = this.departmentsList.map((item: any) => {
          return { value: item._id, label: item.teamName, type: item.type };
        });
        this.filteredDeptOptions = [];
        this.departmentsList.map((item: any) => {
          let myItem:any = this.filteredDeptOptions.find((obj:any)=>{return obj.value == item._id});
          if(myItem == undefined){
            this.filteredDeptOptions.push({ value: item._id, label: item.teamName, type: item.type })
          }
        });
    },
    filterOpen() {
      if (this.columnObject == false) {
        this.showFilters = !this.showFilters;
        emitter.emit("visible", this.showFilters);
      }
    },
  },
});
</script>